// NAV - Desktop 
const bodyClass = document.querySelector('body');
const navHover = document.querySelectorAll('.site-nav--has-dropdown');
const overlayOpen = document.querySelectorAll('.overlay-open');

if (navHover !== null) {
    navHover.forEach((nav) => {
        nav.addEventListener('mouseenter', () => {
            bodyClass.classList.add('no-scroll');
        })

        nav.addEventListener('mouseleave', () => {
            bodyClass.classList.remove('no-scroll');
        })
    })
    overlayOpen.forEach((overlay) => {
        overlay.addEventListener('mouseenter', (e) => {
            e.target.classList.remove('visible');
        })
        overlay.addEventListener('mouseleave', (e) => {
            e.target.classList.add('visible');
        })
    })
}

// NAV - Mobile
const mobNavReturn = document.querySelectorAll('.return-to-parent');
const mobNavTitle = document.querySelectorAll('.collapsible-trigger');
const mobNavSub = document.querySelectorAll('.collapsible-content');

if (mobNavReturn !== null) {
    mobNavReturn.forEach((nav) => {
        nav.addEventListener('click', () => {
            mobNavSub.forEach((sub) => {
                if (sub.classList.contains('is-open')) {
                    sub.classList.remove('is-open');
                }
            })
            mobNavTitle.forEach((sub) => {
                if (sub.classList.contains('is-open')) {
                    sub.classList.remove('is-open');
                }
            })
        })
    })
}

// Slider
const instaSlider = document.querySelector('.gallery-slider');
    if (instaSlider !== null) {
    var flkty = new Flickity( instaSlider, {
    on: {
        ready: function() {
        }
    }
    });
}

// Check header overlay
let headerOverlay = document.querySelector('.header-wrapper--overlay');
if (headerOverlay !== null) {
    document.querySelector('body').classList.add('header-overlay-style');
}